import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';
import { TAgentFirmClientsV2Response } from './types';

type UseAgentFirmClientsOptions = {
  agentFirmId: string;
  enabled?: boolean;
};

/**
 * Hook to fetch all clients for an agent firm (Admin only)
 * GET /agent-firm/:agentFirmId/clients
 */
export function useAgentFirmClients(options: UseAgentFirmClientsOptions) {
  const { agentFirmId, enabled = true } = options;

  const url = agentFirmId ? `${API_BASE_PATH}/${agentFirmId}/clients` : null;

  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data?: TAgentFirmClientsV2Response;
    error?: unknown;
    mutate: KeyedMutator<TAgentFirmClientsV2Response>;
    isLoading: boolean;
  } = useSWR(
    enabled && url ? url : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data: data?.clients ?? [],
    count: data?.count ?? 0,
    error,
    mutate,
    isLoading,
  };
}
